import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import withdrawReducer from "./slices/withdraw";
import profileReducer from "./slices/profile";

import poolReducer from "./slices/pool";


const rootReducer = combineReducers({
  auth: authReducer,
  withdraw: withdrawReducer,
  profile: profileReducer,
  pool: poolReducer,


});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
